var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"href":_setup.iconPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }